<template>
  <div class="d-flex fill-height">
    <v-app-bar
      app
      :height="65"
      color="black"
    >
      <v-img
        style="height: 50px;"
        aspect-ratio="16/9"
        :src="require(`./../assets/clearfxai-logo.png`)"
        max-width="148"
        contain
        class="my-auto"
      >
      </v-img>
    </v-app-bar>

    <v-main 
      class="d-flex justify-center align-center content py-0"
    >
      <v-card
        :width="isSmall||isXSmall ? 350 : 450"
        class="pa-6 mx-auto"
      >
        <v-card-title class="text-h4">
          {{ $t('login.title') }}
        </v-card-title>
        <v-card-text>
          <span style="font-size: 17px !important">{{ $t('login.description.descriptionOne') }}</span>

          <v-form
            v-model="formValid"
            ref="form"
            class="d-flex flex-column mt-6"
          >
            <span class="white--text font-weight-bold">
              {{ $t('login.corporateEmail') }}
            </span>

            <v-text-field
              data-testid="login-email"
              v-model="username"
              dense
              :background-color="'black'"
              :placeholder="$t('login.corporateEmail')"
              outlined
              required
              class="pb-4 pt-2"
            >
              <!-- prepend-inner-icon="mdi-monitor-multiple" -->
              <template v-slot:prepend-inner>
                <v-icon 
                  small
                  color="#a5a5a5"
                  class="pa-1"
                >
                  mdi-monitor-multiple
                </v-icon>
              </template>
            </v-text-field>

            <div class="white--text d-flex font-weight-bold">
              <span>
                {{ $t('login.password') }}
              </span>
              <v-spacer></v-spacer>
              <span
                class="primary--text"
                style="cursor: pointer;"
              >
              <!--{{ $t('login.forgotPassword') }}-->
              </span>
            </div>

            <v-text-field
              data-testid="login-password"
              v-model="password"
              dense
              :background-color="'black'"
              :placeholder="$t('login.password')"
              outlined
              required
              class="pb-4 pt-2"
              :type="showPassword ? 'text' : 'password'"
              hint=""
              :persistent-hint="true"
              @keyup.enter="validate"
            >
              <!-- prepend-inner-icon="mdi-key" -->
              <template v-slot:prepend-inner>
                <v-icon 
                  small
                  color="#a5a5a5"
                  class="pa-1"
                >
                  mdi-key
                </v-icon>
              </template>

              <!-- :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" -->
              <template v-slot:append>
                <v-icon 
                  small
                  class="pa-1"
                  color="#a5a5a5"
                  @click="showPassword = !showPassword"
                >
                  {{ showPassword ? 'mdi-eye' : 'mdi-eye-off' }}
                </v-icon>
              </template>
            </v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!--if small screen-->
          <template v-if="isSmall || isXSmall">
        <v-tooltip bottom open-on-hover>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
            <v-btn
            data-testid="login-submit"
            color="primary"
            elevation="0"
            tile
            :disabled="!formValid || !canSubmit || isXSmall"
            @click="validate"
        >
        <span class="text-capitalize">
          {{ $t('instructions.next') }}
        </span>
      </v-btn>
    </div>
    </template>
        <span>{{ $t('login.invalidSize') }}</span>
        </v-tooltip>
          </template>

          <template v-else>
            <v-btn
            data-testid="login-submit"
            color="primary"
            elevation="0"
            tile
            :disabled="!formValid || !canSubmit"
            @click="validate"
        >
          <span class="text-capitalize">
          {{ $t('instructions.next') }}
        </span>
      </v-btn>
          </template>

        </v-card-actions>
      </v-card>
    </v-main>

    <v-snackbar
      v-model="loginError"
      color="attention"
      :timeout="4000"
    >
      <div class="text-center">
        {{ errorMessage }}
      </div>

      <!-- <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="loginError = false"
        >
          OK
        </v-btn>
      </template> -->
    </v-snackbar>
    <the-footer/>
  </div>
</template>

<script>
import { mapState, mapWritableState, mapActions } from "pinia";
import { useAuthStore,useDisplayStore } from "./../store/index";
import TheFooter from "@/layouts/TheFooter.vue";

export default {
  inject:['changeLanguageFn'],
  components:{
    TheFooter
  },
  data () {
    return {
      formValid: undefined,
      username: undefined,
      password: undefined,
      showPassword: false,
      loadingLogin: false,
      loginError: false,
      errorMessage: undefined
    }
  },
  methods: {
    ...mapActions(useAuthStore, [
      "login",
      "saveSessionLocalStorage"
    ]),
    resolveSafeRedirectPath (rawRedirect) {
      if (typeof rawRedirect !== 'string') return null
      let decoded = ''
      try {
        decoded = decodeURIComponent(rawRedirect).trim()
      } catch {
        return null
      }

      if (!decoded.startsWith('/') || decoded.startsWith('//')) return null
      if (decoded.includes('://')) return null

      // Accept only internal routes to prevent open-redirect abuse.
      const resolved = this.$router.resolve(decoded)
      return resolved?.route?.path ? decoded : null
    },
    validate () {
      // pressing Enter in the password field submits too, past the disabled button.
      if (!this.canSubmit) return
      this.$refs.form.validate()
      if (this.formValid) {
        this.loadingLogin = true
        const data = {
          username: this.username,
          // eslint-disable-next-line
          password: md5(this.password.trim())
        }
        this.login(data)
          .then((response) => {
            const data = response.data
            const userId = data.id
            const userRole = data.role
            this.authenticated = true
            this.userId = userId
            this.saveSessionLocalStorage(data)
            const safeRedirectPath = this.resolveSafeRedirectPath(this.$route.query.redirect)

            if (safeRedirectPath) {
              this.$router.push(safeRedirectPath)
              return
            }

            if (userRole === 'broker') {
              this.$router.push("/grid/broker")
            } else if (userRole === 'pricer') {
              this.$router.push("/grid/engine")
            } else if (userRole === 'console') {
              this.$router.push("/grid/console")
            } else if(userRole === 'partner') {
              this.$router.push('/grid/partner')
            } else {
              this.$router.push("/grid/operations")
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 401) {
              this.loginError = true
              this.errorMessage = this.$t('login.invalidCredentials')
              console.log(error)
            } else if (error.response && error.response.status === 403) {
              this.loginError = true
              const detail = String(error.response?.data?.detail || '').toLowerCase()
              if (detail.includes('blocked') || detail.includes('broker')) {
                this.errorMessage = this.$t('login.companyBlocked')
              } else {
                this.errorMessage = this.$t('login.wrongPassword')
              }
              console.log(error)
            } else if (error.response && error.response.status === 404) {
              this.loginError = true
              this.errorMessage = this.$t('login.userNotFound')
              console.log(error)
            }
          })
          .finally(() => {
            this.loadingLogin = false
          })
      }
    },
  },
  computed: {
    ...mapState(useDisplayStore, [
      "isXSmall",
      "isSmall",
      "isMedium"
    ]),
    ...mapWritableState(useAuthStore, [
      "authenticated",
      "userId",
      "apiKey"
    ]),
    ...mapState(useAuthStore, [
      "isAuthenticated",
      "getUserId"
    ]),
    isPtBRLocale() {
      return this.$i18n.locale === "pt"
    },
    // A password is trimmed before it is hashed, so one of only spaces is none,
    // and a field never typed in holds no string at all.
    canSubmit () {
      return Boolean(this.username && (this.password || '').trim())
    },
  }
}
</script>

<style scoped>
.content {
  background-image: url("./../assets/background-login.svg");
  background-repeat: repeat;
  background-color: #000;
  flex: 1 0 auto;
}
.banner-title {
  background-color: #000;
  color: #fff;
  font-size: 60px;
  font-weight: 500;
  letter-spacing: .29px;
  line-height: 73px;
  max-height: 200px;
  max-width: 520px;
  margin-top: 90px;
  padding: 25px 50px;
  text-align: start;
  word-wrap: break-word;
}
.container-login {
  color: #fff;
  background-color: #000;
  max-width: 460px;
  font-size: 22px;
  text-align: start;
  max-height: 520px;
  height: 500px;
  font-weight: 300;
  padding: 0 10px 0 40px;
}
.footer-menu {
  cursor: pointer;
}
.footer-menu:hover {
  text-decoration: underline;
}
</style>
